import { render, staticRenderFns } from "./CourseCardsFilters3.vue?vue&type=template&id=dbd9e666&"
import script from "./CourseCardsFilters3.vue?vue&type=script&lang=js&"
export * from "./CourseCardsFilters3.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports